import gql from 'graphql-tag';

import { VideoPRODetails } from '../fragments/video';

export const VideosUpload = gql`
  mutation videosUpload($input: VideosUploadInput!) {
    videosUpload(input: $input) {
      videos {
        video {
          ...VideoPRODetails
        }
        upload_url
        multipart_upload {
          id
          parts {
            part_number
            upload_url
          }
        }
      }
    }
  }
  ${VideoPRODetails}
`;

export const VideoUpdate = gql`
  mutation videoUpdate($input: VideoUpdateInput!) {
    videoUpdate(input: $input) {
      video {
        ...VideoPRODetails
      }
    }
  }
  ${VideoPRODetails}
`;

export const VideoDelete = gql`
  mutation videoDelete($input: VideoDeleteInput!) {
    videoDelete(input: $input) {
      success
    }
  }
`;

export const MultipartUploadComplete = gql`
  mutation multipartUploadComplete($input: MultipartUploadCompleteInput!) {
    multipartUploadComplete(input: $input) {
      success
    }
  }
`;

export const MultipartUploadAbort = gql`
  mutation multipartUploadAbort($input: MultipartUploadAbortInput!) {
    multipartUploadAbort(input: $input) {
      success
    }
  }
`;
